export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_08-969cf88027382795245b0a87bc7840ce.jpg";